/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type MediaDeviceReportTrigger =
  (typeof MediaDeviceReportTrigger)[keyof typeof MediaDeviceReportTrigger];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaDeviceReportTrigger = {
  call_started: 'call_started',
  track_republished: 'track_republished',
  device_list_changed: 'device_list_changed',
} as const;
